import { useState } from "react";
import { useDispatch } from "react-redux";
import likeImage from "../../assets/like.svg";
import unlikeImage from "../../assets/unlike.svg";
import { updateVideoLikeUnlike } from "../../features/video/videoAPI";

export default function LikeUnlike({ likes, unlikes, videoId }) {

    const [totalLike, setTotalLike] = useState(likes);
    const [totalUnlike, setTotalUnlike] = useState(unlikes);
    const dispatch = useDispatch();

    const handleLike = () => {
        setTotalLike(totalLike + 1);
        dispatch(updateVideoLikeUnlike(videoId, totalLike + 1, totalUnlike));
    };

    const handleUnLike = () => {
        setTotalUnlike(totalUnlike + 1);
        dispatch(updateVideoLikeUnlike(videoId, totalLike, totalUnlike + 1));
    };

    return (
        <div className="flex gap-10 w-48">
            <div className="flex gap-1">
                <div className="shrink-0 cursor-pointer" onClick = {handleLike}>
                    <img className="w-5 block" src={likeImage} alt="Like" />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {totalLike}
                </div>
            </div>
            <div className="flex gap-1">
                <div className="shrink-0 cursor-pointer" onClick={handleUnLike}>
                    <img className="w-5 block" src={unlikeImage} alt="Unlike" />
                </div>
                <div className="text-sm leading-[1.7142857] text-slate-600">
                    {totalUnlike}
                </div>
            </div>
        </div>
    );
}
